<template>
<div>

<alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

<!--
  <div class="form-group form-check">
    <input type="checkbox" class="form-check-input pointer" id="exampleCheck1" v-model="xml_type">
    <label class="form-check-label" for="exampleCheck1">SCONTRINO DI CORTESIA</label>
  </div>  
-->
</div>

</template>

<script>

//import { mapGetters } from 'vuex';
import api               from '@/api'
import axios             from 'axios'
import alertBox          from '@/components/common/AlertBox.vue'
import { mapGetters }    from 'vuex'
import fmt               from '@/components/mixins/fmt'
import { setFmtDate3}    from '@/functions' 

  export default {
  mixins     : [fmt],
  props : ['url','data','giftTicket','notFiscal'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
          xml      : '',
          crlf     : '\r\n',
          onlyFiscalReceipt : false
          
                          
      }
    },

    
    computed: {
     ...mapGetters(['company']),
      
    },
    
    created () 
      {
        //console.log('EPSON DATA',this.data)
      },
    
    methods: 
    {
    

      async updateFiscalPrintStatus(saleId)
      {
            
            const sp       = {'sp'       :'spUpdateFiscalPrintStatus'}      
            const data     = {'type'     : 'sale','Id': saleId }
            const json     = Object.assign(data, sp);

            await api.post(json).then(res =>{
              if(res.status==200)
              {
            
                  //console.log(res)

              }
              else if(res.status==500)
              {
                console.log(res.data)
              }
              else
              {
                console.log(res)
              }
                                  
                    
          })
        },
        
    getNotFiscal()
    {
      
      const saleId     = this.data.saleId
      const notPaid    = this.data.data[1].filter(item => item.typeId == 'CRED') 

      let notPaidTotal = 0
      notPaid.forEach(item => {
        notPaidTotal += item.total
      })
      
      const SubtotalAdjustment = this.data.data[0][0].total_discount
      const elec_payment       =   this.data.data[1].filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
      let elec_total = 0
            elec_payment.forEach(item=>{
              elec_total += item.total
            })
    
      const crlf         =  '\r\n'  
      const maxLength    = 46  
      
      const spc          = ' '
      const description1 = 'ABBUONO'
      const description2 = 'TOTALE EURO '
      const description3 = 'euro'
      
      let txtFile        =  'printerNonFiscal'  + crlf
      txtFile            += 'beginNonFiscal|1|' + crlf
      txtFile            += 'printNormal|1|1|'  + spc.repeat(maxLength - description3.length)  + 'euro' + crlf
      this.data.data[0].forEach(item => {

        const total        = this.fmt1(item.price)
        const description1 = item.barcode + ' ' + item.category 
        const totalLength  = total.length
        
        txtFile += 'printNormal|1|1|' + description1 + spc.repeat(maxLength - description1.length -  totalLength)  +  total +  crlf     
         if(Number(item.discount > 0))
          {
            const total = '-' + this.fmt1(item.discount_value)
            const description = 'SCONTO ART.'
            const totalLength  = total.length
            txtFile += 'printNormal|1|1|' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  crlf     
                        
          }

      })
      
      const total        = this.fmt1(this.data.data[0][0].total)      
      const totalLength  = total.length
      txtFile += 'printNormal|1|1|' + crlf      
      txtFile += 'printNormal|1|1|' + crlf      
      txtFile += 'printNormal|1|3|' + description2 + spc.repeat(maxLength - description2.length - totalLength) + total + crlf
      if(SubtotalAdjustment > 0)
      {
        const total        = '-' + this.fmt1(SubtotalAdjustment)
        const totalLength  = total.length
        txtFile += 'printNormal|1|3|' + description1 + spc.repeat(maxLength - description1.length - totalLength) + total + crlf  
      }
      txtFile += 'printNormal|1|1|' + crlf      
      txtFile += 'printNormal|1|1|' + crlf  


      this.data.data[1].forEach(item=>{
          if(item.typeId == 'CASH')
          {
            
            const total        = this.fmt1(item.total)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO CONTANTE'
            txtFile += 'printNormal|1|1|' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  crlf     
            
          }
          
        })
        if(elec_total > 0)
        {
            
            const total        = this.fmt1(elec_total)            
            const totalLength  = total.length
            const description  = 'PAGAMENTO ELETTRONICO'
            txtFile += 'printNormal|1|1|' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  crlf     
          
        }
        if(notPaidTotal > 0) 
        {
          
            const total        = this.fmt1(notPaidTotal)            
            const totalLength  = total.length
            const description  = 'NON RISCOSSO'
            txtFile += 'printNormal|1|1|' + description + spc.repeat(maxLength - description.length -  totalLength)  +  total +  crlf     
                    
        }
      
        txtFile += 'printNormal|1|1|' + crlf      
        txtFile += 'printNormal|1|1|' + crlf  
        txtFile += 'printBarCode|1|901|3|120|BELOW|FontA|CODE39|S' + saleId + this.crlf
        txtFile += 'endNonFiscal|1|' + crlf
        
        return txtFile
     
    },




     /* FISCAL RECEIPT */
     getTxtFiscalReceipt()
     {
      
      const saleId = this.data.saleId
      const notPaid = this.data.data[1].filter(item => item.typeId == 'CRED') 
      let notPaidTotal = 0
      notPaid.forEach(item => {
        notPaidTotal += item.total
      })
      
  
      const SubtotalAdjustment = this.data.data[0][0].total_discount
      const elec_payment =   this.data.data[1].filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
      let elec_total = 0
            elec_payment.forEach(item=>{
              elec_total += item.total
            })
      
      let txtFile = ''
      txtFile += 'printerFiscalReceipt' + this.crlf
      txtFile += 'Printer|1' + this.crlf
      this.data.data[0].forEach(item => {
        const price = item.price.toString().replace('.',',')
        txtFile += 'printRecItem|1|' + item.barcode + ' '  + item.category + '|1|' + price +  '|1|1' + this.crlf                              
          if(Number(item.discount > 0))
          {
            const discount = item.discount_value.toString().replace('.',',')
            txtFile += 'printRecItemAdjustment|1|sconto art. |0|' + discount  + '|1|1' + this.crlf
            
          }

        })
        if(SubtotalAdjustment != 0)
        {
          const total = SubtotalAdjustment.toString().replace('.',',')
          txtFile += 'printRecSubtotalAdjustment|1|Sconto sul subtotal|1|' + total + '|1|1' + this.crlf
        }
        if(this.saleId)
        {
          txtFile += 'printRecMessage|1|3|1|1|.   I CAMBI SI EFFETTUANO DA LUNEDI' + this.crlf
          txtFile += "printRecMessage|1|3|2|1|.   A VENERDI ESIBENDO LO SCONTRINO" + this.crlf
          txtFile += "printRecMessage|1|3|3|1|.     ENTRO 7 GIORNI DALL'ACQUISTO." + this.crlf
        
        }
        txtFile += 'printRecSubtotal|3|0' + this.crlf
        if(this.data.saleId)
        {
          txtFile += 'printBarCode|1|901|3|120|BELOW|FontA|CODE39|S' + saleId + this.crlf
        }

        this.data.data[1].forEach(item=>{
          if(item.typeId == 'CASH')
          {
            const totalCash = item.total.toString().replace('.',',')
            txtFile += 'printRecTotal|1|Pagamento contante|' + totalCash + '|0|3|2' + this.crlf
          }
          
        })
        if(elec_total > 0)
        {
          const elecTotal = elec_total.toString().replace('.',',')
          txtFile += 'printRecTotal|1|Pagamento elettronico|' + elecTotal + '|2|1|2' + this.crlf
        }
        if(notPaidTotal > 0) 
        {
          const totalNotPaid = notPaidTotal.toString().replace('.',',')
          txtFile += 'printRecTotal|1|Non riscosso|' + totalNotPaid + '|5|0|1' + this.crlf
        }
        
        txtFile += 'CloseFiscalReceipt|1'
        return txtFile

     },

     /* CREDIT NOTE */
     getTxtCreditNote()
     {

            let txtFile = ''
            const dd           = this.data.creditNote.datasco.substr(0,2)
            const mm           = this.data.creditNote.datasco.substr(2,2)
            const yyyy         = this.data.creditNote.datasco.substr(4,4)
            
            const data_sco     = dd + mm + yyyy

            const total        = this.data.data[1][0].total * -1
            const zNumber      = this.data.creditNote.znumber
            const numSco       = this.data.creditNote.numsco
            const badge_num    = this.data.creditNote.rt_badge

            txtFile += 'printerFiscalReceipt' + this.crlf
            txtFile += 'Printer|1' + this.crlf
            txtFile += 'printRecMessage|1|4|1|1|REFUND ' + zNumber + ' '  + numSco + ' ' + data_sco + ' ' + badge_num + this.crlf
            this.data.data[0].forEach(item => {
              const price = item.price.toString().replace('.',',')
              txtFile += 'printRecRefund|1|' + item.barcode + ' ' + item.category +  '|1|' + price +  '|1|1'  + this.crlf
            })
            txtFile += 'printRecTotal|1|Pagamento contante|0|0|1|0' + this.crlf
            txtFile += 'CloseFiscalReceipt|1'
            
            return txtFile
     },

     /* GIFT */
     getTxtGiftReceipt()
     {
      const saleId = this.data.saleId
      let txtFile = 'printerNonFiscal' + this.crlf
      txtFile += 'beginNonFiscal|1|' + this.crlf
      txtFile += 'printNormal|1|4|SCONTRINO DI CORTESIA' + this.crlf
      

      txtFile += 'printNormal|1|2|' + this.crlf
      txtFile += 'printNormal|1|1|' + this.crlf
      txtFile += 'printNormal|1|1|.   I CAMBI SI EFFETTUANO DA LUNEDI' + this.crlf
      txtFile += "printNormal|1|1|.   A VENERDI ESIBENDO LO SCONTRINO" + this.crlf
      txtFile += "printNormal|1|1|.     ENTRO 7 GIORNI DALL'ACQUISTO." + this.crlf
      txtFile += 'printNormal|1|1|' + this.crlf
      txtFile += 'printBarCode|1|901|3|120|BELOW|FontA|CODE39|S' + saleId + this.crlf
      txtFile += 'endNonFiscal|1|' + this.crlf
      return txtFile


     },
     downLoad(file)
     {
      const data       =  "data:text/csv;charset=utf-8," + file
      const encodedUri = encodeURI(data)
      const link       = document.createElement("a")
      link.setAttribute("href", encodedUri)
      link.setAttribute("download", "sco.txt")
      link.click()    
      this.$emit('finish')
     },
     queryRT()
     {
        
        let xml = '<printerCommand>'
          
          xml += '<queryPrinterStatus operator="1" statusType="0" />'

          xml = '</printerCommand>'
            var soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' +
            xml +
            '</s:Body>\n' +
            '</s:Envelope>\n';
          
          

          axios({
               
                url    : this.url + '/cgi-bin/fpmate.cgi',
                method : 'post',
               /*
                headers : {
                 'Content-Type': 'text/xml; charset=UTF-8',
		              'If-Modified-Since': 'Thu, 01 Jan 1970 00:00:00 GMT',
                  'SOAPAction': '""'
                },
                */
                data   : soap

                

              }).then(res => {
                
                 this.$emit('finish')

                console.log('RT Response',res)

              }).catch(err => {

                //this.$emit('finish')  
                console.log('Errore RT',err)  
              })
        
        
              return


         
     },
     parseFiscalReceiptResponse(xmlResponse)
     {

      const parser              = new DOMParser()
      const xmlDoc              = parser.parseFromString(xmlResponse,"text/xml")
      const response            = xmlDoc.getElementsByTagName("soapenv:Body")[0].childNodes[0].nextSibling.attributes[0].value
          
      let fiscalReceiptNumber   = ''
      let zRepNumber            = ''
      let serialNumber          = ''
      let fiscalReceiptDate     = ''

      if(response == 'true')
      {
        fiscalReceiptNumber       = xmlDoc.getElementsByTagName("fiscalReceiptNumber")[0].childNodes[0].nodeValue
        fiscalReceiptNumber       = fiscalReceiptNumber.padStart(4,'0')
        zRepNumber                = xmlDoc.getElementsByTagName("zRepNumber")[0].childNodes[0].nodeValue
        zRepNumber                = zRepNumber.padStart(4,'0')
        serialNumber              = xmlDoc.getElementsByTagName("serialNumber")[0].childNodes[0].nodeValue
        fiscalReceiptDate         = setFmtDate3(xmlDoc.getElementsByTagName("receiptISODateTime")[0].childNodes[0].nodeValue)
      }
      
      return { 'fiscalReceiptNumber' : fiscalReceiptNumber,
               'zRepNumber'          : zRepNumber,
               'fiscalReceiptDate'   : fiscalReceiptDate,
               'serialNumber'        : serialNumber}
     },
     async saveFiscalReceiptResponse(saleId,data)
     {

      const sp         = {'sp'   : 'spCreateEpsonSaleFiscalReceipt'}          
      const json       = Object.assign(data, sp,{'saleId':saleId})
      console.log(json)
      
      await api.post(json).then(res => {
        if(res.status==200)
            {
              console.log(res.data)
            }
          else if(res.status==500)
           { 
            console.log(res.data)
           }  
           else
            {
              
                
                /*
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                */
                
                 
            } 
          }).catch(err => {
              
              

          }).finally(() => {
          
        });

      
          
     },   
     clickHandler() 
     {

          let xml = ''  

          //console.log(this.data)

          if(this.data.creditNote)
          {
          
            /*
            const dd   = this.data.creditNote.datasco.substr(0,2)
            const mm   = this.data.creditNote.datasco.substr(2,2)
            const yyyy = this.data.creditNote.datasco.substr(4,4)
            */

            const total = this.data.data[1][0].total * -1
            
            const data_sco = this.data.creditNote.datasco
            
            const zNumber = this.data.creditNote.znumber
            const numSco  = this.data.creditNote.numsco
            const badge_num = this.data.creditNote.rt_badge


            xml =  '<printerFiscalReceipt>' 
            xml += '<printRecMessage operator="1" messageType="4" message="REFUND ' + zNumber + ' '  + numSco + ' ' + data_sco + ' ' + badge_num  + '"' + '/>'  
            xml += '<beginFiscalReceipt operator="1" />'
                     
            this.data.data[0].forEach(item => {
              
              xml += '<printRecRefund operator="1" description="' + item.barcode +  ' ' + item.category +  '" quantity="1" unitPrice="' + item.price  + '"  justification="1" />'          
              
              /*
              if(Number(item.discount>0))
              {
              
                //xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value + '" justification = "1" />'  
              
              }
              */

            })
           // xml += '<printRecSubtotal operator="1" Type="1"/>'
            xml += '<printRecTotal operator="1" description="PAGAMENTO CONTANTE " payment="' + total + '" paymentType="0" index="1" justification = "2" />'            
            xml += '<endFiscalReceipt  operator="1"/></printerFiscalReceipt>'
            
            console.log('EPSON FISCAL REFUND',xml)   

          }

          else if(this.giftTicket==false)
          {
          
            let SubtotalAdjustment = this.data.data[0][0].total_discount

            this.data.data[1].forEach(item=>{
              if(item.typeId == 'COUP')
              {
                SubtotalAdjustment += item.total
              }
              if(item.typeId == 'CB')
              {
                SubtotalAdjustment += item.total
              }
            })  
                    
            xml = '<printerFiscalReceipt> <beginFiscalReceipt  operator="1" />'
            xml += '<Printer Num="1" />'
          

            this.data.data[0].forEach(item => {
            
            //xml += '<printRecItem operator="1" description="' + item.barcode + " "  + item.category + '" quantity="1" unitPrice="' + item.price.replace(".",",") + '" justification = "1" />'
            xml += '<printRecItem operator="1" description="' + item.barcode + " "  + item.category + '" quantity="1" unitPrice="' + item.price + '" justification = "1" />'
            
            if(Number(item.discount>0))
            {
              //let val =  Number(item.price) - Number(item.total_row) 
              //xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.sconto_val.toString().replace(".",",") + '" justification = "1" />'  
              
              xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value + '" justification = "1" />'  
              //xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value.replace(".",",") + '" justification = "1" />'  
              //xml += '<printRecItemAdjustment operator="1" adjustmentType="0" description="SCONTO ' + item.discount + '%"' + ' amount="' + item.discount_value.replace(".",",") + '" justification = "1" />'  

            }

          })
          
          
          if(SubtotalAdjustment != '0.00')
          {
            //xml += '<printRecSubtotalAdjustment operator="1" description="SCONTO" Type="1" amount="' + SubtotalAdjustment.replace('.',',') + '" justification = "2" />'
            xml += '<printRecSubtotalAdjustment operator="1" description="SCONTO" Type="1" amount="' + SubtotalAdjustment + '" justification = "2" />'
          }


          xml += '<printRecSubtotal operator="1" Type="1"/>'
          xml += '<printBarCode operator="1" position="901" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.data.saleId + '"/>'
          //xml += '<printBarCode operator="1" position="120" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="CODE39" code="' + "S" +  this.data.saleId + '"/>'
          if(this.data.lottery)
          {
            xml += '<printRecLotteryID operator="1" lotteryID="' + this.data.lottery + '"/>'
          }  

          const total_elec =   this.data.data[1].filter(item => item.typeId == 'ELEC' || item.typeId == 'PAGO' || item.typeId == 'SCAL') 
          this.data.data[1].forEach(item=>{
            if(item.typeId == 'CASH')
            {
              //xml += '<printRecTotal operator="1" description="Pagamento contante" amount="' + item.total.replace('.',',') + '" Type="0" index="3" justification = "2" />'
              xml += '<printRecTotal operator="1" description="Pagamento contante" amount="' + item.total + '" Type="0" index="3" justification = "2" />'
            }
            /*
            if(item.typeId == 'ELEC')
            {
              //xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + item.total.replace('.',',') + '" Type="2" index="1" justification = "2" />'
              xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + item.total + '" Type="2" index="1" justification = "2" />'
            }
            */

            if(item.typeId == 'CRED')
            {
              //xml += '<printRecTotal operator="1" description="Pagamento non riscosso" amount="' + item.total.replace('.',',') + '" Type="2" index="0" justification = "2" />'
              xml += '<printRecTotal operator="1" description="Pagamento non riscosso" amount="' + item.total + '" Type="2" index="0" justification = "2" />'
            }
          })  

           // ELEC PAYMENT
           let total = 0
            total_elec.forEach(item=>{
                
                total += item.total
            })
            
            if(total > 0)
            {
                xml += '<printRecTotal operator="1" description="Pagamento elettronico" amount="' + total + '" Type="2" index="1" justification = "2" />'
                
            }


          xml += '<endFiscalReceipt  operator="1" /></printerFiscalReceipt>'
          this.onlyFiscalReceipt = true
          //console.log('EPSON FISCAL',xml)  
            
          

           }    

           
           else
           {
              xml = '<printerNonFiscal><beginNonFiscal/>'
              xml += '<printNormal operator="1" font="3" data="             SCONTRINO DI CORTESIA" />'
              xml += '<printBarCode  position="901" width="3" height="100" HRIPosition="1" HRIFont="A" codeType="69" code="' + "S" +  this.data.saleId + '"/>'
              //xml += '<printBarCode position="120" width="3" height="120" HRIPosition="1" HRIFont="A" codeType="CODE39" code="' + "S" +  this.data.saleId + '"/>'
              xml += '<endNonFiscal/>'
              //console.log('EPSON NOT FISCAL',xml)    
         
          
           }
           const soap = '<?xml version="1.0" encoding="utf-8"?>\n' +
            '<s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">\n' +
              '<s:Body>\n' +
            xml +
            '</s:Body>\n' +
            '</s:Envelope>\n';
               
            this.xml = xml

          // SOLO PER IL TEMPO NECESSARIO SCALIA
         // console.log('STAMPA',this.notFiscal,this.giftTicket)
          if(this.url.length == 0)
          /*if(this.company.Id == 48 || this.company.Id == 5) */
          {
                
                if(this.data.creditNote)
                {
                  this.downLoad(this.getTxtCreditNote())
                  console.log('PRINT CREDIT NOTE VIA DOWNLOAD FILE.',this.data)
                  /* UPDATE PRINTED FLAG */
                  this.updateFiscalPrintStatus(this.data.saleId)
                  return
                  
                }
                if(this.giftTicket)
                {
                  this.downLoad(this.getTxtGiftReceipt())
                  return
                }
                if(this.notFiscal)
                {
                  this.downLoad(this.getNotFiscal())
                  return  
                }
                this.downLoad(this.getTxtFiscalReceipt())            
                return
          }

          //let  xmlRes = "<?xml version=\"1.0\" encoding=\"utf-8\"?>\n<soapenv:Envelope xmlns:soapenv=\"http://schemas.xmlsoap.org/soap/envelope/\">\n<soapenv:Body>\n<response success=\"true\" code=\"\" status=\"2\">\n\t<addInfo>\n\t<elementList>lastCommand,printerStatus,fiscalReceiptNumber,fiscalReceiptAmount,fiscalReceiptDate,fiscalReceiptTime,receiptISODateTime,zRepNumber,serialNumber</elementList>\n\t\t<lastCommand>74</lastCommand>\n\t\t<printerStatus>00110</printerStatus>\n\t\t<fiscalReceiptNumber>13</fiscalReceiptNumber>\n\t\t<fiscalReceiptAmount>64,57</fiscalReceiptAmount>\n\t\t<fiscalReceiptDate>7/6/2024</fiscalReceiptDate>\n\t\t<fiscalReceiptTime>17:58</fiscalReceiptTime>\n\t\t<receiptISODateTime>20240607T175800</receiptISODateTime>\n\t\t<zRepNumber>1443</zRepNumber>\n\t\t<serialNumber>99MEX099502</serialNumber>\n\t</addInfo>\n</response>\n</soapenv:Body>\n</soapenv:Envelope>\n"
          //xmlRes = xmlRes.replace('\\','')
          
          /*
          const xmlResponse = '<?xml version="1.0" encoding="utf-8"?>\
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/">\
<soapenv:Body>\
<response success="true" code="" status="2">\
	<addInfo>\
	<elementList>lastCommand,printerStatus,fiscalReceiptNumber,fiscalReceiptAmount,fiscalReceiptDate,fiscalReceiptTime,receiptISODateTime,zRepNumber,serialNumber</elementList>\
		<lastCommand>74</lastCommand>\
		<printerStatus>00110</printerStatus>\
		<fiscalReceiptNumber>1</fiscalReceiptNumber>\
		<fiscalReceiptAmount>1,00</fiscalReceiptAmount>\
		<fiscalReceiptDate>7/6/2024</fiscalReceiptDate>\
		<fiscalReceiptTime>9:42</fiscalReceiptTime>\
		<receiptISODateTime>20240607T094200</receiptISODateTime>\
		<zRepNumber>1443</zRepNumber>\
		<serialNumber>99MEX099502</serialNumber>\
	</addInfo>\
</response>\
</soapenv:Body>\
</soapenv:Envelope>'
    
*/
          axios({
               
                url    : this.url + '/cgi-bin/fpmate.cgi',
                method : 'post',
                data   : soap

              }).then(res => {
                console.log('RT Response',res)
                if(this.onlyFiscalReceipt)
                {
                  const response = this.parseFiscalReceiptResponse(res.data)
                  if(response.fiscalReceiptNumber )
                  {

                    this.saveFiscalReceiptResponse(this.data.saleId,response)
                  }
                }

                this.$emit('finish')
                
                
                

              }).catch(err => {
                
                

                //const response = this.parseFiscalReceiptResponse(xmlRes)
                //console.log(response)
                //this.saveFiscalReceiptResponse(this.data.saleId,response)
                
                this.$emit('finish')  
               
                console.log('Errore RT',err)  
              })
        
        
        
   
     } 
      

    }
  }
</script>
<style scoped>





 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
